
@switch (state()) {
  @case (emptyCollectionStates.NoRecords) {
    <ciphr-no-records></ciphr-no-records>
  }
  @case (emptyCollectionStates.NoResults) {
    <ciphr-no-results></ciphr-no-results>
  }
}
